import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";
import ShowMembernewsList from "@/views/BoardView/ShowMembernewsList.vue";
import ShowMemberNews from "@/views/BoardView/ShowMemberNews.vue";
import EditMembernew from "@/views/BoardView/EditMembernew.vue";
import ShowAnnouncementList from "@/views/BoardView/ShowAnnouncementList.vue";
import ShowAnnouncement from "@/views/BoardView/ShowAnnouncement.vue";

const boardMenu = {
  path: "/posts",
  component: DashboardLayout,
  name: "Posts",
  children: [
    {
      path: "membernews",
      name: "membernews",
      component: ShowMembernewsList,
      meta: { requiresAuth: true, title: "topnav.membernews" },
    },
    {
      path: "membernews/detail/:idx",
      name: "membernews-detail",
      component: ShowMemberNews,
      props: true,
      meta: { requiresAuth: true, title: "topnav.membernews" },
    },
    {
      path: "membernews/edit/:idx",
      name: "membernews-edit",
      component: EditMembernew,
      props: true,
      meta: { requiresAuth: true, title: "topnav.membernews" },
    },
    {
      path: "membernews/edit",
      name: "create-membernews",
      component: EditMembernew,
      props: true,
      meta: { requiresAuth: true, title: "topnav.membernews" },
    },
    {
      path: "announcements",
      name: "announcements",
      component: ShowAnnouncementList,
      meta: { requiresAuth: true, title: "topnav.announcements" },
    },
    {
      path: "announcements/:idx",
      name: "announcements-detail",
      component: ShowAnnouncement,
      props: true,
      meta: { requiresAuth: true, title: "topnav.announcements" },
    },
  ],
};

export default boardMenu;
